export const upcomingAudiobooks = [
  {
    id: 1,
    icon: 'ri-moon-clear-line',
    format: 'Voz de Mercedes',
    title: 'Dormí Tranquila — El Audiolibro',
    description: 'La guía completa del sueño del bebé de 0 a 12 meses, narrada con calma para escuchar en cualquier momento.',
  },
  {
    id: 2,
    icon: 'ri-brain-line',
    format: 'Neurociencia en audio',
    title: 'El Cerebro de tu Bebé y el Sueño',
    description: 'Neurociencia aplicada al sueño infantil explicada en palabras simples, para que entiendas qué pasa en su cerebro cuando duerme.',
  },
  {
    id: 3,
    icon: 'ri-heart-pulse-line',
    format: 'Voz guiada',
    title: 'Yoga para Calmar a tu Bebé',
    description: 'Secuencias suaves de yoga mamá-bebé para relajar antes de dormir, narradas paso a paso con voz guiada.',
  },
  {
    id: 4,
    icon: 'ri-windy-line',
    format: 'Meditación guiada',
    title: 'Meditaciones para Mamás Cansadas',
    description: 'Meditaciones guiadas breves, pensadas para esos momentos en que solo necesitás respirar y volver a vos.',
  },
];